export const singleData = {
    iframeTabs: [
        { title: 'Outside', key: 'EXT' },
        { title: 'Inside', key: 'INT' },
        {
            title: 'Underneath', key: 'UNDERNEATH'
        }
    ],
    
    beforeAfterTabs:[
        { title: 'Spin 360 + Hotspots', key: 'hotspot', },
        { title: 'Spin 360 only', key: 'not_hotspot' }
    ]
}